export const QuestItem = {
	name: 'QuestItem',
	position: {
		x: 0,
		y: 0
	},
	components: [
		{
			name: 'bg_quest',
			type: 'Sprite',
			img: 'quest_bg_mobile',
			position: { x: -5, y: -5 },
			alpha: 0.2
		},
		{
			name: 'itemheader',
			type: 'Text',
			position: { x: 140, y: 6 },
			text: 'QUEST_ITEM_HEADER'
		},
		{
			name: 'icon',
			type: 'Sprite',
			img: 'trophy_icon',
			position: { x: 140, y: 44 }
		},
		{
			name: 'itemsubtitle',
			type: 'Text',
			position: { x: 170, y: 44 },
			text: 'QUEST_ITEM_SUBTITLE'
		},
		{
			name: 'itemdesc',
			type: 'Text',
			position: { x: 0, y: 44 },
			text: 'QUEST_ITEM_DESC'
		}
	]
};
